const capitalizeFirst = (string: string) => `${string.charAt(0).toUpperCase()}${string.substring(1)}`

export {
  capitalizeFirst
}
